import React, { useState } from 'react';
import { Button, Card, ErrorAlert } from '../../../components/shared';

export default function LinkAccountFlow({
  flowState,
  initResult,
  phonePostals = [],
  onSubmitLink,
  onSubmitOtp,
  onBack,
  loading,
  error,
  FLOW,
}) {
  const [idNumber, setIdNumber] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phonePostal, setPhonePostal] = useState('84');
  const [otp, setOtp] = useState('');

  const handleSubmitLink = (e) => {
    e.preventDefault();
    onSubmitLink(idNumber, phoneNumber, phonePostal);
  };

  const handleSubmitOtp = (e) => {
    e.preventDefault();
    if (initResult?.sessionToken) {
      onSubmitOtp(initResult.sessionToken, otp);
    }
  };

  if (flowState === FLOW.LINK_OTP) {
    return (
      <div className="mx-auto max-w-md">
        <Card>
          <form onSubmit={handleSubmitOtp} className="space-y-5">
            <div className="text-center">
              <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-blue-50">
                <svg className="h-7 w-7 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900">Nhập mã OTP</h3>
              <p className="mt-1 text-sm text-gray-500">
                Mã OTP đã được gửi đến số điện thoại của bạn
              </p>
            </div>

            <div>
              <input
                type="text"
                inputMode="numeric"
                maxLength={6}
                placeholder="Nhập 6 số OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                className="w-full rounded-lg border border-gray-300 px-4 py-3 text-center text-2xl font-semibold tracking-widest focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                autoFocus
              />
            </div>

            <ErrorAlert error={error} />

            <div className="flex gap-3">
              <Button
                variant="secondary"
                className="flex-1"
                onClick={onBack}
                type="button"
              >
                Quay lại
              </Button>
              <Button
                className="flex-1"
                type="submit"
                loading={loading}
                disabled={otp.length < 6}
              >
                Xác nhận
              </Button>
            </div>
          </form>
        </Card>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-md">
      <Card>
        <form onSubmit={handleSubmitLink} className="space-y-5">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Liên kết tài khoản Fmarket</h3>
            <p className="mt-1 text-sm text-gray-500">
              Nhập thông tin tài khoản Fmarket hiện có của bạn
            </p>
          </div>

          <div className="space-y-4">
            <div>
              <label className="mb-1.5 block text-sm font-medium text-gray-700">Số CMND/CCCD</label>
              <input
                type="text"
                value={idNumber}
                onChange={(e) => setIdNumber(e.target.value)}
                placeholder="Nhập số CMND hoặc CCCD"
                className="w-full rounded-lg border border-gray-300 px-3 py-2.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div>
              <label className="mb-1.5 block text-sm font-medium text-gray-700">Số điện thoại</label>
              <div className="flex gap-2">
                {phonePostals.length > 0 ? (
                  <div className="w-28">
                    <select
                      value={phonePostal}
                      onChange={(e) => setPhonePostal(e.target.value)}
                      className="w-full rounded-lg border border-gray-300 bg-white px-2 py-2.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      {phonePostals.map((p) => {
                        const callingCode = p.extraData?.calling_code || p.code;
                        return (
                          <option key={p.code} value={callingCode}>+{callingCode}</option>
                        );
                      })}
                    </select>
                  </div>
                ) : (
                  <div className="w-20">
                    <input
                      type="text"
                      value={phonePostal}
                      onChange={(e) => setPhonePostal(e.target.value.replace(/\D/g, ''))}
                      className="w-full rounded-lg border border-gray-300 px-3 py-2.5 text-center text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="84"
                    />
                  </div>
                )}
                <input
                  type="tel"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="Số điện thoại"
                  className="flex-1 rounded-lg border border-gray-300 px-3 py-2.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
            </div>
          </div>

          <ErrorAlert error={error} />

          <div className="flex gap-3">
            <Button
              variant="secondary"
              className="flex-1"
              onClick={onBack}
              type="button"
            >
              Quay lại
            </Button>
            <Button
              className="flex-1"
              type="submit"
              loading={loading}
              disabled={!idNumber || !phoneNumber}
            >
              Liên kết
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
}
